import { FEATURED_SCOOP, SCOOP_REQUESTS } from '@/mocks/scoopRequests';

const STATS = [
  { num: '27', label: '在办征集令' },
  { num: '160+', label: '已采信独立线索' },
  { num: '9', label: '跟进求证事件' },
];

const TICKER = [
  { tag: '新征集', text: '论文“代写代发”中介报价与流程截图，正在征集中' },
  { tag: '新征集', text: '某团体出道夜“换票”疑云，寻现场应援手幅与落座记录' },
  { tag: '已采信', text: '“到手价缩水”已采信 2 条交叉印证线索，进入平台核验' },
  { tag: '新征集', text: '各行业“无偿试岗”岗位与面试截图，避坑名单持续更新' },
  { tag: '求料', text: '寻“以旧换新”补贴未到账案例，统一汇总处理' },
];

export default function Hero() {
  const sideItems = [...SCOOP_REQUESTS].filter((s) => s.urgency === '火' || s.urgency === '急').slice(0, 3);

  return (
    <section id="top" className="relative overflow-hidden bg-foreground-950 text-foreground-50">
      {/* decorative background */}
      <div className="pointer-events-none absolute -left-28 -top-24 h-80 w-80 rounded-full bg-primary-500/20 blur-3xl" aria-hidden="true"></div>
      <div className="pointer-events-none absolute right-0 top-40 h-96 w-96 rounded-full bg-accent-500/10 blur-3xl" aria-hidden="true"></div>
      <span
        className="pointer-events-none absolute -right-6 top-10 select-none font-heading text-[11rem] font-black leading-none text-foreground-50/[0.035] md:text-[17rem]"
        aria-hidden="true"
      >
        XL
      </span>

      <div className="relative mx-auto max-w-7xl px-4 pt-28 md:px-6 md:pt-36">
        {/* meta strip */}
        <div className="flex items-center justify-between border-b border-foreground-50/15 pb-4">
          <p className="flex items-center gap-2 text-[12px] font-medium tracking-wide text-foreground-300">
            <span className="flex h-2 w-2 rounded-full bg-primary-500"></span>
            编辑部正在征集 · 每日扫核
          </p>
          <p className="hidden text-[12px] text-foreground-400 sm:block">2026 / 09 · 第 74 期</p>
        </div>

        <div className="grid grid-cols-1 gap-10 py-10 md:py-14 lg:grid-cols-12 lg:gap-12">
          {/* headline copy */}
          <div className="lg:col-span-7">
            <p className="inline-flex items-center gap-2 rounded-full border border-primary-400/40 bg-primary-500/10 px-3 py-1.5 text-[13px] font-semibold text-primary-200">
              <i className="ri-broadcast-line" aria-hidden="true"></i>
              爆料征集令 · 全网寻料求料
            </p>
            <h1 className="mt-6 font-heading text-4xl font-black leading-[1.18] tracking-tight text-foreground-50 md:text-6xl">
              有料不知道发给谁？
              <br />
              让<span className="text-primary-400">隐藏的瓜</span>被看见、被核实。
            </h1>
            <p className="mt-6 max-w-xl text-[15px] leading-relaxed text-foreground-300 md:text-base">
              寻料站是专注<span className="font-semibold text-foreground-100">爆料征集令</span>与
              <span className="font-semibold text-foreground-100">线索征集</span>的中转与求证平台。想找线索、
              想求料、手里有截图和关键信息——都在这里发布征集令，公开寻料求料，围观多线索扫核。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#submit"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-[15px] font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-send-plane-fill" aria-hidden="true"></i>
                提供线索 / 求料
              </a>
              <a
                href="#board"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-50/25 px-6 py-3.5 text-[15px] font-semibold text-foreground-100 transition-colors hover:border-foreground-50/60 hover:bg-foreground-50/5"
              >
                围观征集令
                <i className="ri-arrow-down-line" aria-hidden="true"></i>
              </a>
            </div>

            <dl className="mt-10 grid grid-cols-3 gap-4 border-t border-foreground-50/15 pt-6 sm:gap-6">
              {STATS.map((s) => (
                <div key={s.label}>
                  <dt className="sr-only">{s.label}</dt>
                  <dd className="font-heading text-2xl font-black text-foreground-50 md:text-4xl">{s.num}</dd>
                  <dd className="mt-1 text-[13px] text-foreground-400">{s.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          {/* quick side feed */}
          <aside className="lg:col-span-5">
            <div className="h-full rounded-lg border border-foreground-50/12 bg-foreground-50/[0.04] p-5 md:p-6">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-lg font-bold text-foreground-50">寻料速览</h3>
                <a
                  href="#board"
                  className="flex items-center gap-1 text-[13px] font-semibold text-primary-300 hover:text-primary-200"
                >
                  全部征集 <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
                </a>
              </div>
              <p className="mt-1 text-[13px] text-foreground-400">优先处理 · 高热度征集令</p>

              <div className="mt-5 space-y-3">
                {sideItems.map((item, i) => (
                  <a
                    key={item.id}
                    href="#board"
                    className="group flex gap-3.5 rounded-md border border-foreground-50/10 bg-foreground-50/[0.03] p-3.5 transition-colors hover:border-primary-400/40 hover:bg-foreground-50/[0.06]"
                  >
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-sm bg-primary-500/20 font-heading text-sm font-bold text-primary-300">
                      {i + 1}
                    </span>
                    <div className="min-w-0">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="rounded-sm bg-primary-500 px-1.5 py-0.5 text-[11px] font-bold text-background-50">
                          {item.urgency}
                        </span>
                        <span className="text-[12px] text-foreground-400">{item.category}</span>
                      </div>
                      <p className="mt-1.5 line-clamp-2 text-[13px] leading-snug text-foreground-200 group-hover:text-foreground-50">
                        {item.title}
                      </p>
                    </div>
                  </a>
                ))}
              </div>

              <a
                href="#verify"
                className="mt-4 flex items-center justify-between rounded-md border border-accent-500/30 bg-accent-500/10 px-4 py-3 text-[13px] font-semibold text-accent-300 transition-colors hover:bg-accent-500/15"
              >
                <span className="flex items-center gap-2">
                  <i className="ri-magic-line" aria-hidden="true"></i>
                  围观《{FEATURED_SCOOP.title.slice(0, 6)}…》求证工作台
                </span>
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </div>
          </aside>
        </div>
      </div>

      {/* breaking marquee */}
      <div className="relative flex items-stretch border-t border-foreground-50/15">
        <div className="z-10 flex shrink-0 items-center gap-2 bg-primary-500 px-4 py-2.5 text-background-50 md:px-5">
          <i className="ri-flashlight-fill text-base" aria-hidden="true"></i>
          <span className="whitespace-nowrap font-heading text-[13px] font-bold tracking-wide">线索速递</span>
        </div>
        <div className="relative flex-1 overflow-hidden py-2.5" aria-hidden="true">
          <div className="marquee-track">
            {[0, 1].map((loop) => (
              <ul key={loop} className="flex shrink-0 items-center">
                {TICKER.map((t, i) => (
                  <li key={`${loop}-${i}`} className="flex items-center gap-3 whitespace-nowrap px-6 text-[13px] text-foreground-300">
                    <span className={'rounded-sm px-1.5 py-0.5 text-[11px] font-bold ' + (t.tag === '已采信' ? 'bg-accent-500/20 text-accent-300' : 'bg-primary-500/20 text-primary-300')}>
                      {t.tag}
                    </span>
                    {t.text}
                  </li>
                ))}
              </ul>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}